var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '../../strings/i18n/i18n';
import SyfStorage from '../../helpers/SyfStorage';
import { ErrorInfoWrapper } from '../../ui/atoms';
import { useAccountsInfoData } from '../../ui/customHooks';
import AlertsLazyLoader from '../../ui/molecules/AlertsLazyLoader';
import { FeatureFlagProvider } from '../../context/FeatureFlag';
import MainPage from './MainPage';
import { AccountsDataNotAvailableInfo, PreferenceCenterContainer, PreferenceCenterTitle } from './subcomponents';
var PreferenceCenter = function (_a) {
    var platform = _a.platform, config = _a.config, handleProfileClick = _a.handleProfileClick;
    var t = useTranslation().t;
    var token = SyfStorage.getAccessToken();
    var _b = useAccountsInfoData(config, platform), _c = _b.data, accountsInfo = _c === void 0 ? [] : _c, isLoading = _b.isLoading, isError = _b.isError;
    var currentLanguage = SyfStorage.getLanguage();
    var invalidAccountsData = accountsInfo === null || accountsInfo === void 0 ? void 0 : accountsInfo.some(function (data) { return !data; });
    var hasNoAccountsData = (isError || (accountsInfo === null || accountsInfo === void 0 ? void 0 : accountsInfo.length) < 1 || invalidAccountsData) && !isLoading;
    useEffect(function () {
        i18n.changeLanguage(currentLanguage);
    }, [currentLanguage]);
    var errorBody = !token
        ? t('errorPage.default')
        : t('errorPage.accountsDataNotAvailable');
    if (!token || hasNoAccountsData) {
        return (_jsx(AccountsDataNotAvailableInfo, __assign({ "data-test": "AccountsDataNotAvailableInfo" }, { children: _jsx(ErrorInfoWrapper, { errorBody: errorBody, errorTitle: t('errorPage.title') }) })));
    }
    return (_jsxs(PreferenceCenterContainer, { children: [_jsx(PreferenceCenterTitle, { children: t('headerLabels.marketingPrivacySettings') }), isLoading ? (_jsx(AlertsLazyLoader, {})) : (_jsx(FeatureFlagProvider, { children: _jsx(MainPage, { platform: platform, accountsInfo: accountsInfo, handleProfileClick: handleProfileClick, config: config }) }))] }));
};
export default PreferenceCenter;
